import React, { Component } from 'react';
import Translation from "../../../../../common/translation/translation.component";
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import {InputFieldFloatingLabel as InputField } from "../../../../../common/custom-form/select-filter.component";
import TableWithButton from "../../../../../common/details-table/table-with-button.component";
import { MAX_LENGTH, PLAN_COMPONENT_PROPNAME } from "../../../../../../constants/external-constants";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

class ContractCommitment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: "",
            viewDetailPage: false,
            titleBtn: false,
            enableAddBtn: false,
            enableEdit: false,
            keyIndex: null,
            selectedValue: '',
            activeDropdown: true,
            showDetails: false,
            modalMessage: "",
            showModal: false,
            dataTable: [],
            isExist: false,
            fieldChange: false,
            loading: true,
            tableLength: 0,
            showNotif: false,
            notifTitle: null,
            updatePlanComponentDetails: false,
            selectedItems: '',
            isError: false,
            hasError: {},
        }
    }

    handelEnableEdit = (enable, index) => {
        this.setState({ enableEdit: enable, keyIndex: index })
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }

    handleOpenNotif = (title) => {
        this.setState({
            showNotif: true,
            notifTitle: title
        });
    }

    setDefaultError = () => {
        this.setState({
            hasError: {}
        });
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    render() {
        const { translator, contractForm } = this.props;

        return (
            <>
            
                <CustomDropdown
                    label={<Translation translationKey={"contract_commitment"} />}
                    activeDropdown={this.state.activeDropdown}
                    toggleActiveState={this.toggleActiveState}
                >
                    <div className="contract-container add-sim-container add-cost-allocation-cont">
                        <div className="details-4-col-26-container capital-uppercase">
                            <NotificationModal
                                show={this.state.showNotif}
                                title={this.state.haveError ? 'Error' : 'Success'}
                                message={this.state.modalMessage ? this.state.modalMessage : `Plan Details ${this.state.notifTitle} successfully!`}
                                handleModal={this.handleCloseNotif}
                                customClass={'comment-notification-modal notification-footer modal-text-bold'}
                            />
    
                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"term_commitment_volume"} />}
                                value={contractForm.contractCommitment.termCommitmentVolume}
                                fieldProp='contractForm.contractCommitment.termCommitmentVolume'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}

                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"annual_commitment_volume"} />}
                                value={contractForm.contractCommitment.annualCommitmentVolume}
                                fieldProp='contractForm.contractCommitment.annualCommitmentVolume'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false} 
                                placeholder={translator("enter_text_placeholder")}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"sub_commitment"} />}
                                value={contractForm.contractCommitment.subCommitment}
                                fieldProp='contractForm.contractCommitment.subCommitment'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}
                            />
                             <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"escalating_commitment"} />}
                                value={contractForm.contractCommitment.escalatingCommitment}
                                fieldProp='contractForm.contractCommitment.escalatingCommitment'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}
                            />
                             <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"exclusivity"} />}
                                value={contractForm.contractCommitment.exclusivity}
                                fieldProp='contractForm.contractCommitment.exclusivity'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}
                            />

                             <div className="grid-col-span-2 capital-uppercase">
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"description"} />}
                                    value={contractForm.contractCommitment.description}
                                    fieldProp='contractForm.contractCommitment.description'
                                    maxLength={MAX_LENGTH.limit_255}
                                    disabled={false}
                                    placeholder={translator("enter_text_placeholder")}
                                />
                            </div>
                        </div>

                        <div className="details-table-container ">

                            <TableWithButton
                                datatable={[]}
                                haveDeleteBtn={(this.props.isReadAndWrite ? true : false)}
                                haveEditBtn={(this.props.isReadAndWrite ? true : false)}
                                deleteAction={() =>{}}
                                updateAction={this.updatePlanComponent}
                                searchableDropdownData={[]}
                                inputField={PLAN_COMPONENT_PROPNAME}
                                optionsMap={[]}
                                selectedItems={[]}
                                selectedValue={this.state.selectedItems}
                                percentValue={this.props.percentValue}
                                handleSelectChange={() => { }}
                                handleInputChange={() =>{}}
                                handleOpenNotif={this.handleOpenNotif}
                                handleGetFieldData={() =>{}}
                                handelEnableEdit={this.handelEnableEdit}
                                enableEdit={this.state.enableEdit}
                                keyIndex={this.state.keyIndex}
                                clearSelectedValue={this.clearSelectedValue}
                                hasError={this.state.hasError}
                                planComponentError={this.state.isError}
                                setDefaultError={this.setDefaultError}
                            />

                        </div>
                    </div>
                </CustomDropdown>
            </>
        );
    }
}

export default withRouter(connect(
    state => {
        const { contractDetails, translation } = state;
        const { contractForm, forms: { contractForm: { $form } } } = state.form;
        return {
            ...translation,
            contractDetails,
            contractForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}), dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(ContractCommitment));